var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-button",class:{ active: _vm.active, disabled: _vm.disabled, border: _vm.border },style:(_vm.innerStyle),on:{"click":_vm.emitClick}},[_c('span',{staticClass:"icon",class:_vm.icon}),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-32f1791e","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/ui-button/src/ui-button.vue
// module id = 680
// module chunks = 0